export default "__VITE_ASSET__BVqz32wl__"